import type { BadgeColour, BadgeVariant } from 'components/Badge';
import Badge from 'components/Badge';
import TooltipWrap from 'components/TooltipWrap';
import i18n from 'i18n';
import { TaskPriority } from 'pages/assignments/consts';
import { FunctionComponent } from 'react';
import { getEnumKey } from 'utils/enum';

interface PriorityTagI {
  priority: string | number;
  variant?: BadgeVariant;
  tooltip?: boolean;
}

const PriorityTag: FunctionComponent<PriorityTagI> = ({
  priority,
  variant,
  tooltip
}: PriorityTagI) => {
  const tagPriority =
    typeof priority === 'number'
      ? getEnumKey(TaskPriority, priority) || 'NORMAL'
      : priority;

  const label = () =>
    String(tagPriority).charAt(0).toUpperCase() +
    String(tagPriority).slice(1).toLocaleLowerCase();

  const color = (): BadgeColour => {
    switch (tagPriority) {
      case 'URGENT':
        return 'darkRed';
      case 'HIGH':
        return 'red';
      case 'NORMAL':
        return 'blue';
      case 'LOW':
        return 'green';
      default:
        return 'gray';
    }
  };

  const badge = (
    <Badge label={label()} color={color()} variant={variant} icon="dot" />
  );

  if (tooltip)
    return (
      <TooltipWrap title={i18n.t('pages.assignments.tooltip.priority')}>
        {badge}
      </TooltipWrap>
    );

  return badge;
};

export default PriorityTag;

PriorityTag.defaultProps = {
  tooltip: false,
  variant: 'square'
};
